import { useEffect, useMemo, useRef } from 'react';
import { TargetElementObserver } from 'target-element-observer';
import { useToggleComponent } from 'navigation-components/platform/hooks';
import { NAV_ONBOARDING_TOURS_COMPONENT } from 'navigation-components/config';
import { useAppSelector } from '../../../hooks/redux';
import { selectShouldShowNav, selectShouldShowToolbar } from '../../../overlayDisplayConfig/selectors';
import { isSeleniumRunning } from '../../../utils/testEnv';
import { isInOnboardingSession, isOnboardingTourCurrentlyActive, shouldRenderOnboardingTour } from '../../../deferred/onboarding-tours/utils';
import { partyAlive, Party } from 'nav-onboarding-tours/communication';
import useEffectOnce from '../../../hooks/useEffectOnce';
import { get } from '../../../utils/tempStorage';
import { jsx as _jsx } from "react/jsx-runtime";
const bypassSeleniumRunningForTourATs = () => {
  return get('BYPASS_SELENIUM_RUNNING_FOR_TOUR_ATS') === 'true';
};
export const NavOnboardingTourSupport = () => {
  const {
    toggle
  } = useToggleComponent(NAV_ONBOARDING_TOURS_COMPONENT, {
    useScheduler: true
  });
  const navVisible = useAppSelector(selectShouldShowNav);
  const toolbarVisible = useAppSelector(selectShouldShowToolbar);
  const wasNavTourRequested = useRef(false);
  const shouldShowTour = useMemo(() => Boolean(
  // Makes sure nav and toolbar are visible
  navVisible && toolbarVisible && (
  // Makes sure we are not in an acceptance test
  !isSeleniumRunning() || bypassSeleniumRunningForTourATs()) &&
  // Makes sure there is no regular onboarding tour
  // https://product.hubteam.com/docs/growth-onboarding/engineering-docs/onboarding-tours/getting-started.html
  !isInOnboardingSession() && !isOnboardingTourCurrentlyActive() && !shouldRenderOnboardingTour()), [navVisible, toolbarVisible]);
  useEffectOnce(() => {
    const unsubscribe = partyAlive(Party.UNIFIED_NAVIGATION_UI, party => {
      if (party === Party.APP_STARTING_TOUR && !wasNavTourRequested.current) {
        toggle(shouldShowTour);
        wasNavTourRequested.current = true;
      }
    });
    return unsubscribe;
  });
  useEffect(() => {
    if (wasNavTourRequested.current) {
      toggle(shouldShowTour);
      return;
    }
    if (!shouldShowTour) {
      return;
    }
  }, [shouldShowTour, toggle]);
  if (!shouldShowTour) {
    return null;
  }
  return /*#__PURE__*/_jsx(TargetElementObserver, {});
};